<template>
  <CDropdown placement="bottom-end" :caret="false" in-nav class="c-header-nav-item d-md-down-none mx-2"
             add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div @click="loadData(false, true)">
          <CIcon name="cil-bell"/>
          <CBadge shape="pill" color="danger" v-if="total != 0">{{total}}</CBadge>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>Bạn có {{itemsCount}} thông báo</strong>
    </CDropdownHeader>
    <li v-if="isRender" style="text-align: center;margin-top: 10px;"><span class="fa fa-spinner fa-spin"></span></li>
    <template v-for="each in data">
      <CDropdownItem :style="each.status == 0 ? 'background:none;' : 'background:rgba(170,170,170,0.10);'">
        <!--        <CIcon name="cil-user-follow" class="text-success"/>-->
        {{each.content}}
      </CDropdownItem>
    </template>
    <div v-if="data.length < itemsCount" class="text-center view-plus" @click="loadDataShowMore">
      Xem thêm
    </div>
    <!--    <CDropdownHeader tag="div" class="text-center bg-light">-->
    <!--      <strong>Server</strong>-->
    <!--    </CDropdownHeader>-->
    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="text-uppercase mb-1">-->
    <!--        <small><b>CPU Usage</b></small>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="info" :value="25"/>-->
    <!--      <small class="text-muted">348 Processes. 1/4 Cores.</small>-->
    <!--    </CDropdownItem>-->
    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="text-uppercase mb-1">-->
    <!--        <small><b>Memory Usage</b></small>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="warning" :value="70"/>-->
    <!--      <small class="text-muted">11444GB/16384MB</small>-->
    <!--    </CDropdownItem>-->
    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="text-uppercase mb-1">-->
    <!--        <small><b>SSD 1 Usage</b></small>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="danger" :value="90"/>-->
    <!--      <small class="text-muted">243GB/256GB</small>-->
    <!--    </CDropdownItem>-->
  </CDropdown>
</template>
<script>

  import helper from '../helper.js'

  export default {
    name: 'TheHeaderDropdownNotif',
    data() {
      return {
        isRender: true,
        total: 0,
        itemsCount: 0,
        data: [],
        pageNumber: 0,
      }
    },
    mounted() {
      this.loadNewNotification();
    },
    methods: {
      redirect500: function (error) {
        helper.logOut();
        if (error && error.response && error.response.status === 401 || error && error.status === 401) {
          this.$router.push('/');
        } else {
          this.$router.push('/pages/500');
        }
      },
      loadData: function (isShowMore, isUpdate) {
        let page = 0;
        if (isShowMore) {
          page = this.pageNumber + 1;
        }
        helper.postApi(
          '/notification/listByDateAndUser',
          {page: page},
          // 'page=' + page,
          {},
          false,  
          response => {
            this.isRender = false;
            let data = response.data;
            let data_result = data.data;
            if (data.returnCode !== 1) {
              this.redirect500();
            } else {
              if (isShowMore) {
                this.itemsCount = data_result.totalElement;
                this.data = this.data.concat(data_result.dataContent.content);
                this.pageNumber = page;
              } else {
                this.itemsCount = data_result.totalElement;
                this.data = data_result.dataContent.content;
                this.pageNumber = 0;
              }
            }
          },
          error => {
            this.redirect500(error);
          })
        if (isUpdate) {
          helper.postApi(
            '/notification/updateStatus',
            {},
            {},
            false,
            response => {
              let data = response.data;
              if (data.returnCode !== 1) {
                this.redirect500();
              } else {
                this.total = 0;
              }
            },
            error => {
              this.redirect500(error);
            })
        }
      },
      loadDataShowMore: function () {
        this.loadData(true, false);
      },
      loadDataAgain: function () {
        this.loadData(false, false);
      },
      loadNewNotification: function () {
        helper.postApi(
          '/notification/countTotalNewNotifUser',
          {},
          {},
          false,
          response => {
            let data = response.data;
            let data_result = data.data;
            if (data.returnCode !== 1) {
              this.redirect500();
            } else {
              this.total = data_result;
            }
          },
          error => {
            this.redirect500(error);
          })
      },
      excuteUpdateStatus: function () {
        helper.postApi(
          '/notification/updateStatus',
          {},
          {},
          response => {
            let data = response;
            if (data.returnCode !== 1) {
              // this.redirect500();
            } else {
              // this.total = 0;
            }
          },
          error => {
            this.redirect500(error);
          })
      }
    },
    watch: {
      '$route': ['loadDataAgain', 'loadNewNotification']
    },
  }
</script>

<style scoped>
  .view-plus {
    cursor: pointer;
    padding: 10px 20px;
  }

  .view-plus:hover {
    text-decoration: underline;
  }
</style>
